module.exports = __webpack_public_path__ + "static/media/ic-category-review-on.104cd773.svg";